import { useEffect } from 'react'

const CHECK_INTERVAL = 5000 // 5 seconds

export function useVersionChecker() {
  const checkVersion = async () => {
    try {
      console.log('Checking for new version...')
      const res = await fetch('/version.json', { cache: 'no-store' })
      const { version } = await res.json()

      const current = localStorage.getItem('app-version')

      if (!current) {
        localStorage.setItem('app-version', version)
      } else if (current !== version) {
        // Re-read before writing to avoid overwriting a newer version set by another tab
        const freshCurrent = localStorage.getItem('app-version')
        if (freshCurrent === version) return
        console.log('New version detected:', version)
        localStorage.setItem('app-version', version)
        if (window.location.pathname.startsWith('/auth/verify')) return
        window.location.replace(window.location.href)
      }
    } catch (err) {
      console.log('Version check failed:', err)
    }
  }

  useEffect(() => {
    checkVersion() // Run on first load

    const interval = setInterval(checkVersion, CHECK_INTERVAL)

    return () => clearInterval(interval)
  }, [])
}
